// extracted by mini-css-extract-plugin
module.exports = {"prompt":"CallBackModal_prompt_3Xbi6"};